import { Column } from "react-table";

export default [
    {
        Header: 'Name',
        accessor: 'name',
        width: "100%"
    }
] as Column<Interfaces.Section>[]